import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Avatar, Button, Divider, Stack } from "@mui/material";
import { Images } from "../../assets/common";
import {
  formatedDate,
  fullName,
  getErrorString,
  getTimeDue,
  isOwner,
  isOwnerId,
  truncate,
} from "../../constants/function";
import DoneIcon from "@mui/icons-material/Done";
import BuyNow from "../../components/BuyNow";
import TipPopup from "../../components/TipPopup";
import Loader from "./../../components/Loader";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import { useDispatch } from "react-redux";
import { getBalance } from "../../asyncAction/asyncBalance";
import NoData from "../../components/Nodata";
import { useTranslation } from "react-i18next";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{ minHeight: "300px" }}
    >
      {value === index && (
        <Box sx={{ padding: "10px 0" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function NftMoreData({ musicDetail, owners, nftIndex }) {
  const { t } = useTranslation("common");
  const [charges, setCharges] = React.useState({});
  const [offers, setOffers] = React.useState([]);
  const [activities, setActivities] = React.useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openTip, setOpenTip] = useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [viewMore, setViewMore] = React.useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) getOffers(musicDetail["_id"]);
    if (newValue === 2) getActivities(musicDetail["_id"]);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const handleClose = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTip(false);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const getOffers = async (musicId) => {
    try {
      const response = await ApiService.OFFERS(
        `${musicId}&rank=${owners?.rank}`
      );
      setOffers(response["result"]);
    } catch (error) {}
  };
  const getActivities = async (musicId) => {
    try {
      const response = await ApiService.ACTIVITY(
        `${musicId}&rank=${owners?.rank}`
      );
      setActivities(response["result"]);
    } catch (error) {}
  };

  const getCharges = async () => {
    try {
      const response = await ApiService.CHARGES();
      setCharges({ ...response["result"] });
    } catch (error) {}
  };

  React.useEffect(() => {
    getCharges();
  }, []);
  const flaguser = async () => {
    try {
      const response = await ApiService.FLAG_USER({
        message: "Reason",
        assetId: musicDetail["_id"],
        verify: musicDetail["uploader"]
          ? musicDetail["uploader"]["_id"]
          : musicDetail["owner"]["_id"],
      });
      notifier.success(t("notifier.success.toast4"));
    } catch (error) {}
  };
  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }} position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          // textColor="default"
          variant="fullWidth"
          aria-label="Nft more details"
        >
          <Tab
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={
                  value === 0 ? Images.more_details_active : Images.more_details
                }
                alt=""
              />
            }
            label={t("nftDetail.tabs2.tab1")}
            {...a11yProps(0)}
          />
          <Tab
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 1 ? Images.offers_active : Images.offers}
                alt=""
              />
            }
            label={t("nftDetail.tabs2.tab2")}
            {...a11yProps(1)}
          />
          <Tab
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 2 ? Images.activity_active : Images.activity}
                alt=""
              />
            }
            label={t("nftDetail.tabs2.tab3")}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <Box
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        // onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Stack direction="column" spacing={2}>
            <Stack
              direction="row"
              sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}
            >
              <Stack diretion="column" spacing={1}>
                <Stack direction="row" spacing={1}>
                  <Typography className="fs-14 fw-b white-secondary">
                    {t("nftDetail.detail.creator.text1")}
                  </Typography>
                  <Typography className="fs-14 faded">
                    {musicDetail["ownerRoyalty"]}%{" "}
                    {t("nftDetail.detail.creator.text2")}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar"
                    src={
                      musicDetail["uploader"]["profileImg"]
                        ? musicDetail["uploader"]["profileImg"]["filePath"]
                        : Images.user_dummy
                    }
                    alt=""
                  />
                  <Typography className="fs-14">
                    {fullName(musicDetail["uploader"])}
                  </Typography>
                  {musicDetail["uploader"]["isVerified"] ? (
                    <DoneIcon
                      color="primary"
                      sx={{
                        backgroundColor: "#2CF488",
                        borderRadius: "50%",
                        fontSize: "14px",
                        color: "#1E1E1E",
                        padding: "2px",
                      }}
                    />
                  ) : null}
                </Stack>
              </Stack>
              {/* <Stack diretion="column" spacing={1}>
                <Stack direction="row" spacing={1}>
                  <Typography className="fs-14 fw-b white-secondary">
                    {t("nftDetail.detail.artist")}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar"
                    src={
                      musicDetail["uploader"]["profileImg"]
                        ? musicDetail["uploader"]["profileImg"]["filePath"]
                        : Images.user_dummy
                    }
                    alt=""
                  />
                  <Typography className="fs-14">
                    {fullName(musicDetail["uploader"])}
                  </Typography>
                  {musicDetail["uploader"]["isVerified"] ? (
                    <DoneIcon
                      color="primary"
                      sx={{
                        backgroundColor: "#2CF488",
                        borderRadius: "50%",
                        fontSize: "14px",
                        color: "#1E1E1E",
                        padding: "2px",
                      }}
                    />
                  ) : null}
                </Stack>
              </Stack> */}
            </Stack>
            <Divider sx={{ borderColor: "#FFFFFF19", width: "81%" }} />
            <Stack diretion="column" spacing={1}>
              <Stack direction="row" spacing={1}>
                <Typography className="fs-14 fw-b white-secondary">
                  {t("searchResult.header3")}
                </Typography>
              </Stack>
              <Stack className="_nft_multi_artist">
                {musicDetail.artistData
                  ? musicDetail.artistData.map((a, index) => (
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        key={index}
                      >
                        <img
                          className="avatar"
                          src={
                            a["profileImg"] ? a?.profileImg : Images.user_dummy
                          }
                          alt=""
                        />
                        <Typography
                          className="fs-14"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          {a?.displayArtistName}
                        </Typography>
                      </Stack>
                    ))
                  : null}
              </Stack>
            </Stack>
            <Divider sx={{ borderColor: "#FFFFFF19", width: "81%" }} />
            <Stack
              direction="row"
              sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}
            >
              <Stack direction="column" spacing={1}>
                <Typography className="fs-13 fade-text-60">
                  {t("nftDetail.detail.createdDate")}
                </Typography>
                <Typography className="fs-16 fw-b">
                  {formatedDate(owners["createdDate"])}
                </Typography>
              </Stack>
              <Stack direction="column" spacing={1}>
                <Typography className="fs-13 fade-text-60">
                  {t("nftDetail.detail.nft")}
                </Typography>
                {owners ? (
                  <Typography className="fs-16 fw-b">
                    {owners["nftCount"]}
                  </Typography>
                ) : null}
              </Stack>
            </Stack>
            <Stack spacing={0.5}>
              <Typography className="fs-13 fade-text">
                {t("addPopup.explicit")}
              </Typography>
              <Typography className="fs-17">
                {musicDetail["isExplicit"]
                  ? t("nftDetail.detail.explicit.yes")
                  : t("nftDetail.detail.explicit.no")}
              </Typography>
            </Stack>
            {musicDetail["releaseDate"] ? (
              <Stack spacing={0.5}>
                <Typography className="fs-13 fade-text">
                  {t("nftDetail.detail.releaseDate")}
                </Typography>
                <Typography className="fs-17">
                  {formatedDate(musicDetail["releaseDate"])}
                </Typography>
              </Stack>
            ) : null}
            {musicDetail["ISRCCode"] ? (
              <Stack spacing={0.5}>
                <Typography className="fade-text">
                  {t("nftDetail.detail.ISRCCode")}
                </Typography>
                <Typography>{musicDetail["ISRCCode"]}</Typography>
              </Stack>
            ) : null}
            <Stack spacing={0.5}>
              <Typography className="fs-15 fade-text">
                {t("nftDetail.detail.parties")}
              </Typography>
              {musicDetail["collaborators"].map((party, index) => (
                <Stack
                  spacing={15}
                  key={index}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography className="fs-15">{party["role"]}</Typography>
                  <Typography className="fs-17">
                    {fullName(party["_id"])}
                  </Typography>
                </Stack>
              ))}
            </Stack>
            {musicDetail["rank"] ? (
              <Stack spacing={0.5}>
                <Typography className=" fs-13 fade-text">
                  {t("nftDetail.detail.rank")}
                </Typography>
                <Typography className="fs-17">{owners["rank"]}</Typography>
              </Stack>
            ) : null}
            {musicDetail["royalties"] && musicDetail["royalties"].length > 0 ? (
              <Stack>
                <Typography className="fs-13 fade-text">
                  {t("songDetail.text8")}
                </Typography>
                <Stack spacing={1}>
                  {musicDetail["royalties"].map((r, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Typography className="fs-15 ">
                        {r["percentage"]}%
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        spacing={1}
                      >
                        <Typography className="fs-13 canceled">
                          {isOwner(r["_id"]["email"])}
                        </Typography>
                        <Typography className="fs-17">
                          {fullName(r["_id"])}
                        </Typography>
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              </Stack>
            ) : null}
            {musicDetail["ownerRoyalty"] ? (
              <Stack direction="column">
                <Typography className="fs-13 fade-text">
                  {t("songDetail.text9")}
                </Typography>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography className="fs-15">
                    {musicDetail["ownerRoyalty"]
                      ? musicDetail["ownerRoyalty"]
                      : 0}
                    %
                  </Typography>
                  <Typography className="fs-15">
                    {fullName(
                      musicDetail["uploader"] ? musicDetail["uploader"] : ""
                    )}
                  </Typography>
                </Stack>
              </Stack>
            ) : null}
            {!isOwnerId(owners["owner"]["_id"]) ? (
              <Box
                sx={{
                  height: "180px",
                  borderRadius: "15px",
                  border: "1px dashed #4D4D4D",
                  padding: "16px",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Stack direction="column">
                    <Typography className="fs-20" sx={{ paddingBottom: "10px" }}>
                      {t("tipBox.header")}
                    </Typography>
                    <Typography className="fs-14">
                      {t("tipBox.subHeader")}
                    </Typography>
                    <Typography className="fs-14" sx={{ paddingBottom: "20px" }}>song owner.</Typography>
                    <Button
                      onClick={() => setOpenTip(true)}
                      sx={{ height: "36px", marginTop: "auto" }}
                      variant="outlined"
                    >
                      {t("tipBox.button")}
                    </Button>
                  </Stack>
                  <img
                    src={Images.tipOwner}
                    alt=""
                  />
                </Stack>
              </Box>
            ) : null}
            {(musicDetail["owner"] || musicDetail["uploader"]) &&
            !isOwnerId(
              musicDetail["owner"]
                ? musicDetail["owner"]["_id"]
                : musicDetail["uploader"]
                ? musicDetail["uploader"]["_id"]
                : ""
            ) &&
            !musicDetail["isPlaylistNft"] ? (
              <Stack sx={{ marginTop: "10px !important" }} spacing={1}>
                <Stack spacing={1} direction="row" alignItems="center">
                  <img src={Images.flag} alt="flag" />
                  <Typography className="fs-13 fade-text">
                    {t("flag") + " " + t("home.tabs.music.tab")}
                  </Typography>
                </Stack>
                <Stack spacing={1} alignItems="flex-start">
                  <Typography className="fs-15 fade-text">
                    {t("flagMsg")}
                  </Typography>
                  <Button
                    variant="outlined"
                  >
                    {t("flag")}
                  </Button>
                </Stack>
              </Stack>
            ) : null}
          </Stack>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Stack
            sx={{
              // backgroundColor: "#262626",
              backgroundColor: "#171515",
              borderRadius: "16px",
              height: "41px",
              padding: "0 20px",
              display: "grid",
              gridTemplateColumns: "20% 20% 20% 20% 20%",
              alignItems: "center",
            }}
          >
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th5")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th1")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th2")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th3")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th4")}
            </Typography>
          </Stack>
          {offers.length > 0 ? (
            offers.map((offer, index) => (
              <Stack
                key={index}
                sx={{
                  height: "41px",
                  padding: "5px 20px",
                  borderBottom: "1px solid #404040",
                  display: "grid",
                  gridTemplateColumns: "20% 20% 20% 20% 20%",
                  alignItems: "center",
                }}
              >
                <Typography
                  className="white-secondary fs-14"
                  title={offer["rank"]}
                >
                  {offer["rank"]}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={
                      offer["currency"] === "siki"
                        ? Images.siki_coin
                        : Images.hbar_1
                    }
                    alt=""
                  />
                  <Typography
                    className="white-secondary fs-14"
                    title={offer["amount"]}
                  >
                    {truncate(offer["amount"].toFixed(2), 5)}
                  </Typography>
                </Stack>
                <Typography
                  className="white-secondary fs-14"
                  title={offer["usdPrice"]}
                >
                  ${truncate(offer["usdPrice"].toFixed(2), 5)}
                </Typography>
                <Typography className="white-secondary fs-14">
                  {offer["endDate"] ? getTimeDue(offer["endDate"]) : "-"}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar-sm"
                    src={
                      offer?.fromUser?.profileImg?.filePath ||
                      Images.default_user
                    }
                    alt="siki"
                  />
                  <Typography className="white-secondary fs-14">
                    {fullName(offer["fromUser"])}
                  </Typography>
                </Stack>
              </Stack>
            ))
          ) : (
            <Box sx={{ position: "relative", minHeight: "200px" }}>
              <NoData lable={t("noData.noData")} />
            </Box>
          )}
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Stack
            sx={{
              // backgroundColor: "#262626",
              backgroundColor: "#171515",
              borderRadius: "16px",
              height: "41px",
              padding: "0 20px",
              display: "grid",
              gridTemplateColumns: "10% 15% 11% 11% 22% 16% 15%",
              alignItems: "center",
            }}
          >
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th1")}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th7")}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th2")}
            </Typography>
            <Typography
              className="white-secondary fs-13 white-space-pre text-center "
              title={t("nftDetail.activity.th3")}
            >
              {truncate(t("nftDetail.activity.th3"), 10)}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th4")}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th5")}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th6")}
            </Typography>
          </Stack>
          {activities.length > 0 ? (
            activities.map((activity, index) => (
              <Stack
                key={index}
                sx={{
                  // height: "41px",
                  padding: "5px 20px",
                  borderBottom: "1px solid #404040",
                  display: "grid",
                  gridTemplateColumns: "10% 15% 11% 12% 19% 19% 14%",
                  alignItems: "center",
                }}
              >
                <Typography className="white-secondary fs-14 text-center">
                  {activity["typeOfNft"]}
                </Typography>
                <Typography
                  className="white-secondary fs-14 text-center"
                  title={activity["rank"]}
                >
                  {activity["rank"]}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={
                      activity["currency"] === "siki"
                        ? Images.siki_coin
                        : Images.hbar_1
                    }
                    alt=""
                  />
                  <Typography
                    className="white-secondary fs-14 text-center "
                    title={activity["amount"]}
                  >
                    {truncate(activity["amount"].toFixed(2), 5)}
                  </Typography>
                </Stack>
                <Typography
                  className="white-secondary fs-14 text-center"
                  title={activity["usdPrice"]}
                >
                  $ {truncate(activity["usdPrice"].toFixed(2), 5)}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar-sm"
                    src={
                      activity?.fromUser?.profileImg?.filePath ||
                      Images.default_user
                    }
                    alt="siki"
                  />
                  <Typography className="white-secondary fs-14 text-center">
                    {fullName(activity["fromUser"])}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar-sm"
                    src={
                      activity?.toUser?.profileImg?.filePath ||
                      Images.default_user
                    }
                    alt="siki"
                  />
                  <Typography className="white-secondary fs-14 text-center">
                    {fullName(activity["toUser"])}
                  </Typography>
                </Stack>
                <Typography className="white-secondary fs-14 text-center">
                  {formatedDate(activity["createdAt"], true, true, false, true)}
                </Typography>
              </Stack>
            ))
          ) : (
            <Box sx={{ position: "relative", minHeight: "200px" }}>
              <NoData lable={t("noData.noData")} />
            </Box>
          )}
        </TabPanel>
      </Box>
      {viewMore ? (
        <BuyNow
          view={true}
          owners={owners}
          open={viewMore}
          handleClose={() => setViewMore(false)}
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={
            owners["owner"]
              ? fullName(owners["owner"])
              : fullName(owners["uploader"])
          }
          id={
            owners["owner"] ? owners["owner"]["_id"] : owners["uploader"]["_id"]
          }
          open={openTip}
          isArtist={true}
          handleClose={handleClose}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={t("loader.message10")}
        />
      ) : null}
    </Box>
  );
}
